import _createClass from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var LoggedInToken = /*#__PURE__*/_createClass(function LoggedInToken() {
  var _this = this;
  _classCallCheck(this, LoggedInToken);
  _defineProperty(this, "key", "loginInProgress");
  _defineProperty(this, "setLogInPorgress", function () {
    window.sessionStorage.setItem(_this.key, "yes");
  });
  _defineProperty(this, "removeLogInProgress", function () {
    window.sessionStorage.removeItem(_this.key);
  });
  _defineProperty(this, "isLoginProgress", function () {
    return window.sessionStorage.getItem(_this.key) === "yes";
  });
});
export default new LoggedInToken();